"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica Join BGP Optimize Query Operation Actor.
 */


var ActorOptimizeQueryOperationJoinBgp =
/*#__PURE__*/
function (_bus_optimize_query_o) {
  _inherits(ActorOptimizeQueryOperationJoinBgp, _bus_optimize_query_o);

  function ActorOptimizeQueryOperationJoinBgp(args) {
    _classCallCheck(this, ActorOptimizeQueryOperationJoinBgp);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorOptimizeQueryOperationJoinBgp).call(this, args));
  }

  _createClass(ActorOptimizeQueryOperationJoinBgp, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var operation;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                operation = sparqlalgebrajs_1.Util.mapOperation(action.operation, {
                  join: function join(op, factory) {
                    if (op.left.type === 'bgp' && op.right.type === 'bgp') {
                      return {
                        recurse: false,
                        result: factory.createBgp(op.left.patterns.concat(op.right.patterns))
                      };
                    } else {
                      return {
                        recurse: false,
                        result: op
                      };
                    }
                  }
                });
                return _context2.abrupt("return", {
                  operation: operation
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorOptimizeQueryOperationJoinBgp;
}(bus_optimize_query_operation_1.ActorOptimizeQueryOperation);

exports.ActorOptimizeQueryOperationJoinBgp = ActorOptimizeQueryOperationJoinBgp;